import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams, withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import { MobileRegularPage, MobileOutlinedButton, MobileButton, MobileTextField, repliValidator } from "../../../components";
import useStyles from './EmailConfirmation.style';

const EmailConfirmation = (props) => {
    const { token } = useParams();
    const classes = useStyles();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [error, setError] = useState('');
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const validator = useRef(repliValidator());

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_AUTH_EMAILCONFIRMATION}/${token}`)
            .then(response => {
                if (!response.ok) response.json().then((json) => { setError(json.message) });
            }).catch(error => {
                console.error(error);
                setError(t('signUpEmailConfirmation.feedbackMessage.error'));
            }).finally(() => {
                setLoading(false);
            });
    }, [token, t]);

    const handleResend = () => {
        setSubmitted(true);
        const isValid = validator.current.allValid();

        if (!isValid) {
            validator.current.showMessages();
            return;
        }

        setSending(true);
        fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_AUTH_RESENDTOKEN}`, {
            method: 'post',
            body: new URLSearchParams({
                email: email
            })
        }).then(response => {
            if (!response.ok) {
                response.json().then((json) => { setError(json.message) });
            } else {
                props.history.push('/app/signup/success');
            }
        }).catch(error => {
            console.error(error);
            setError(t('signUpEmailConfirmation.feedbackMessage.error'));
        }).finally(() => {
            setSending(false);
        });
    }

    if (loading) return (
        <></>
    )

    return (
        <MobileRegularPage>
            <Box className={classes.iconSection}>
                {error
                    ? <ErrorOutlineIcon className={classes.iconFailure} />
                    : <CheckCircleOutlineIcon className={classes.iconSuccess} />
                }
            </Box>
            <Box className={classes.textSection}>
                <Typography variant="h4">
                    {t(`signUpEmailConfirmation.feedbackMessage.${error ? 'failure' : 'success'}`)} {error}
                </Typography>
            </Box>
            {error &&
                <Box className={classes.resendSection}>
                    <Typography variant="h5">Need a new token?</Typography>
                    <MobileTextField
                        label="Email"
                        error={submitted && !validator.current.fieldValid('email')}
                        onChange={e => setEmail(e.target.value)}
                        helperText={validator.current.message('email', email, 'required|email')} />
                    <MobileOutlinedButton
                        label={t('signUpEmailConfirmation.buttonLabels.tokenResend')}
                        onClick={handleResend}
                        loading={sending} />
                </Box>
            }
            <Box className={classes.footer}>
                <MobileButton
                    label={t('signUpEmailConfirmation.buttonLabels.goToSignIn')}
                    className={classes.button}
                    component={Link}
                    to="/app/signin" />
            </Box>
        </MobileRegularPage>
    );
};

export default withRouter(EmailConfirmation);